/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import Credits from '../base/Credits';
import IFrame from '../base/IFrame';
import Teasers from '../base/Teasers';
import Flourish from '../base/Flourish';
import Graphic from '../graphics/Graphic';
import AdPosition from '~components/base/AdPosition';


import FeatureFormat from '../combo_templates/FeatureFormat';
import FourColFormat from '../combo_templates/FourColFormat';
import TwoColFormat from '../combo_templates/TwoColFormat';



//Data is  array of content items that are either archie or body (usually just 2 items (one each))
//in this case we will always have one archie object as the first element in the array, followed by everything else. tweak if needed
//Send this data to the component to format accordingly
//that component should be able to handle an array and format text or archie object

//Data is an array
const ComboElement = ({ data, type}) => {

  if (type=="feature"){
    console.log(type)
    return (<FeatureFormat data={data} />);
  }

  if (type=="four-col"){
    console.log(type)
    return (<FourColFormat data={data} />);
  }

  if (type=="two-col"){
    console.log(type)
    return (<TwoColFormat data={data} />);
  }

  return (
    null
  );
};
ComboElement.propTypes = {
  data: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['custom_embed']),
    subtype: PropTypes.oneOf(['archieml']),
    archieJson: PropTypes.string,
    _id: PropTypes.string,
  }).isRequired,
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      headlines: PropTypes.shape({
        basic: PropTypes.string,
      }),
      promoImage: PropTypes.shape({
        sizes: PropTypes.shape({
          _480: PropTypes.string,
        }),
        srcSet: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ),
};

ComboElement.defaultProps = {
  relatedLinks: null,
};

export default ComboElement;
